import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

const MAX_NOTE = 500;

interface SolicitarCambiosDialogProps {
	open: boolean;
	resourceName: string;
	onClose: () => void;
	onConfirm: (note: string) => void;
}

const SolicitarCambiosDialog: React.FC<SolicitarCambiosDialogProps> = ({
	open,
	resourceName,
	onClose,
	onConfirm,
}) => {
	const [note, setNote] = useState('');

	const handleClose = () => {
		setNote('');
		onClose();
	};

	const trimmed = note.trim();

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth='sm'>
			<DialogTitle>Solicitar cambios</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					fullWidth
					multiline
					minRows={3}
					margin='dense'
					label='Comentario'
					placeholder={`Qué debe cambiar en ${resourceName}`}
					value={note}
					onChange={(event) => setNote(event.target.value.slice(0, MAX_NOTE))}
					helperText={`${note.length}/${MAX_NOTE}`}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancelar</Button>
				<Button
					variant='contained'
					disabled={trimmed.length === 0}
					onClick={() => {
						onConfirm(trimmed);
						setNote('');
					}}
				>
					Solicitar cambios
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SolicitarCambiosDialog;
